import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Button2Component } from '@frontendlib/components/components/button/button2.component';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { NoContentStubComponent } from '@frontendlib/components/components/no-content-stub/no-content-stub.component';
import { File } from '@modules/files/types/file';
import { FilesService } from '@modules/files/services/files.service';

@Component({
  selector: 'app-unsupported-preview',
  templateUrl: './unsupported-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [Button2Component, IconComponent, NoContentStubComponent],
  host: { class: 'block w-full h-full' },
})
export class UnsupportedPreviewComponent {
  public readonly file = input.required<File>();

  private readonly filesService = inject(FilesService);

  protected download(): void {
    this.filesService.download(this.file());
  }
}
